<template>
  <article class="about" id="step1">
      <img src="../../assets/images/about/about.png" style="width: 100%;" alt="">
    <!-- 主体内容 -->
  <div class="padding">
    <div class="about1">
      <div class="title">
        <div>
          联系我们
        </div>
        <div class="yinwen">
          CONTACT US
        </div>
        <img src="../../assets/images/index/shenglue.png" alt="">
      </div>
    </div>
    <div class="content">
      <div class="item">
        <img src="../../assets/images/about/mailbox.svg" alt="">
        <div class="abbreviation">邮箱</div>
        <div class="name">wudi@sh-decent9999.com</div>
      </div>
      <div class="item">
        <img src="../../assets/images/about/position.svg" alt="">
        <div class="abbreviation">地址</div>
        <div class="name">上海市静安区江场西路299弄<br/> 中铁中环时代广场6号楼</div>
      </div>
      <div class="item">
        <img src="../../assets/images/about/Telephone.svg" alt="">
        <div class="abbreviation">电话</div>
        <div class="name">13916961742</div>
      </div>
      <div class="item">
        <img src="../../assets/images/about/Zipcode.svg" alt="">
        <div class="abbreviation">邮编</div>
        <div class="name">200436</div>
      </div>
    </div>
  </div>

  </article>

</template>

<script>
// import {
//   Toast
// } from 'vant';

export default {
  // name: 'join-us',

  data() {
    return {
      borderLeftSelected: '2px solid #E63019 !important',
      borderLeftNormal: '2px solid #FFFFFF !important',
      Pcmodel: false,
    }
  },
  created() {
  },
  mounted() {


    // 判断当前用户是手机端还是pc端
    if (this.isMobile()) {
      // alert("手机端");
      this.Pcmodel = false
    } else {
      // alert("pc端");
      this.Pcmodel = true
    }
  },
  methods: {
    //判断当前手机端还是pc端的方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag;
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@screen-xs-min: 768px;
@screen-md-min: 992px;
@screen-lg-min: 1200px;

* {
  padding: 0;
}


.about {
  margin: 0 auto;
  @media screen and(min-width: 770px) {
    margin-top: 80px;
  }
  @media screen and(max-width: 770px) {
    margin-top: 50px;
  }

  // 主体内容
  .content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    @media screen and(max-width:1024px){
    //  display: block;
      flex-wrap: wrap;
    }
    .item{
      width: 48%;
    }
    img{
      width: 40px;
      height: 40px;
      margin-top: 30px;
      @media screen and(max-width:1024px){
        margin-top: 20px;
        width: 20px;
        height: 20px;
      }
      @media screen and(max-width:768px){
        margin-top: 10px;
        width: 16px;
        height: 16px;
      }
    }
    .abbreviation{
      margin-top: 20px;
      font-size: 16px;
      @media screen and(max-width:1024px){
        margin-top: 12px;
        font-size: 15px;
      }
      @media screen and(max-width:768px){
        margin-top: 10px;
        font-size: 13px;
      }
    }
    .name{
      margin-top: 20px;
      @media screen and(max-width:1024px){
        margin-top: 16px;
        font-size: 15px;
      }
      @media screen and(max-width:768px){
        margin-top: 2px;
        font-size: 12px;
      }
    }
  }
}
.padding{
  padding: 80px 0 100px;
  @media screen and(max-width:1200px){
    padding: 40px 0  50px;
  }
  @media screen and(max-width:768px){
    padding: 20px 0 30px;
  }
}
.about1 {
    .title{
      font-size: 35px;
      font-weight: 300;
      color: #000000;
      @media screen and(max-width:1720px){
        font-size: 32px;
      }
      @media screen and(max-width:1640px){
        font-size: 30px;
      }
      @media screen and(max-width:1520px){
        font-size: 28px;
      }
      @media screen and(max-width:1380px){
        font-size: 26px;
      }
      @media screen and(max-width:1200px){
        font-size: 24px;
      }
      @media screen and(max-width:1180px){
        font-size: 22px;
      }
      @media screen and(max-width:1024px){
        font-size: 20px;
      }
      @media screen and(max-width:1005px){
        width: 100%;
        font-size: 20px;
      }
      @media screen and(max-width:768px){
        width: 100%;
        font-size: 20px;
      }
      @media screen and(max-width:540px){
        font-size: 20px;
      }
      .yinwen{
        color: #999999;
        font-size: 24px;
        @media screen and(max-width:1200px){
          font-size: 18px;
        }
        @media screen and(max-width:768px){
          font-size: 15px;
        }
      }
      img{
        width: 110px;
        @media screen and(max-width:1200px){
          width: 90px;
        }
        @media screen and(max-width:768px){
          width: 60px;
        }
      }
    }
}
</style>
